var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _vm.canChangeAccessory
        ? _c(
            "v-layout",
            { attrs: { row: "", "justify-end": "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    "x-small": "",
                    text: "",
                    icon: "",
                    color: "accent",
                    disabled: _vm.disabled
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("addAccessory", "create")
                    }
                  }
                },
                [_c("v-icon", [_vm._v("add_circle")])],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("accessories-and-others-table", {
        attrs: {
          "can-change-accessory": _vm.canChangeAccessory,
          accessories: _vm.accessoriesSelected,
          disabled: _vm.disabled
        },
        on: {
          "delete-item": function($event) {
            return _vm.$emit("delete-item", $event)
          },
          "edit-item": function($event) {
            return _vm.$emit("edit-item", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73623c86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73623c86","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/AccessoriesAndOthers/AccessoriesAndOthersList.vue
// module id = null
// module chunks = 